import axios from 'axios';

export const defaultState = {
  trancheUtilizations: [],
};

export const mutations = {
  SET_STRATEGIES_TRANCHE_UTILIZATIONS_DATA(trancheUtilizationState, data) {
    trancheUtilizationState.trancheUtilizations = data;
  },
};

export const getters = {
  getStrategiesTrancheUtilizations: contractState => contractState.trancheUtilizations,
};

export const actions = {
  fetchStrategiesTrancheUtilizations({ commit }) {
    return axios.get(`${window.BASE_API.STRATEGIES_SETTLEMENT}/tranche/utilization`)
      .then(({ data }) => {
        commit('SET_STRATEGIES_TRANCHE_UTILIZATIONS_DATA', data.data);

        return data;
      })
      .catch((error) => {
        commit('SET_STRATEGIES_TRANCHE_UTILIZATIONS_DATA', []);

        return Promise.reject(error);
      });
  },
  calculateStrategiesTrancheUtilizationByTrancheIdManually(store, payload) {
    return axios.post(`${window.BASE_API.STRATEGIES_SETTLEMENT}/tranche/utilization/${payload.trancheId}/calculateManual`, payload)
      .then(({ data }) => data)
      .catch(error => Promise.reject(error));
  },
};

const strategiesTrancheUtilizations = {
  state: defaultState,
  mutations,
  getters,
  actions,
};

export default strategiesTrancheUtilizations;



// WEBPACK FOOTER //
// ./src/store/settlements/strategiesTrancheUtilization.js